module.exports = __webpack_public_path__ + "media/images/frontend/lamberet/separator-8d4f4095595435e2b217416111276283.png";